<template>
    <merge-colour :colour="entityRecord"></merge-colour>
</template>
<style scoped>
</style>
<script>
    import { mapState } from "vuex";
    export default {
        name: "ColourToolbar",
        data: function () {
            return {
            };
        },
        props: {
        },
        methods: {
        },
        computed: {
            ...mapState({
                entity: (state) => state.entities.entity,
                entityRecord: (state) => state.entities.entityRecord,
                entityRecordLoading: (state) => state.entities.entityRecordLoading
            })
        },
    };
</script>
